export namespace Constant {
    const mobileBreakPoint = 768;

    export const theme = {
        colors: {
            body: '#fff',
            font: '#464646',
        },
        mobilePx: mobileBreakPoint,
        mobile: `${mobileBreakPoint}px`,
    }
}
